/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var Input_1 = require("./Input");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-input-valueGroup");
var InputValueGroups = /** @class */ (function (_super) {
    tslib_1.__extends(InputValueGroups, _super);
    function InputValueGroups() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputs = [];
        _this.onChange = function (groupIndex, evt) {
            var value = evt.target.value;
            var group = _this.props.groups[groupIndex];
            if (value.length === group.mask.length && !!_this.inputs[groupIndex + 1]) {
                _this.inputs[groupIndex + 1].focus();
            }
            _this.props.onChange(evt, _this.getValue());
        };
        _this.onBlur = function (evt) {
            /* Forward blur events and send the grouped values with */
            if (_this.props.onBlur) {
                _this.props.onBlur(evt, _this.getValue());
            }
        };
        _this.onClick = function (evt) {
            var lastFilledInput = _this.inputs
                .slice()
                .reverse()
                .find(function (inputElement) { return !!inputElement.value; });
            if (lastFilledInput) {
                lastFilledInput.focus();
            }
            else {
                _this.inputs[0].focus();
            }
            if (_this.props.onClick) {
                _this.props.onClick(evt);
            }
        };
        _this.onKeyDown = function (groupIndex, evt) {
            if (evt.keyCode === 8) {
                // delete
                if (!_this.inputs[groupIndex].value.length &&
                    _this.inputs[groupIndex - 1]) {
                    evt.preventDefault();
                    _this.inputs[groupIndex - 1].focus();
                }
            }
        };
        _this.onKeyUp = function (groupIndex, evt) {
            /**
             * If a printable character was written,
             * the inputs value has reached its masks length,
             * and it is not the last group, focus the next groups input
             */
            if (InputValueGroups.isPrintableKeyCode(evt.keyCode) &&
                _this.inputs[groupIndex].value.length ===
                    _this.props.groups[groupIndex].mask.length &&
                groupIndex < _this.props.groups.length - 1) {
                evt.preventDefault();
                _this.inputs[groupIndex + 1].focus();
            }
        };
        _this.onFocus = function (evt) {
            try {
                var target = evt.target;
                target.setSelectionRange(0, target.value.length);
            }
            catch (err) { }
            if (_this.props.onFocus) {
                _this.props.onFocus(evt);
            }
        };
        return _this;
    }
    InputValueGroups.prototype.getValue = function () {
        return this.inputs.map(function (input) { return input.value; });
    };
    InputValueGroups.prototype.render = function () {
        var _this = this;
        var _a = this.props, groups = _a.groups, delimiter = _a.delimiter, value = _a.value, onBlur = _a.onBlur, props = tslib_1.__rest(_a, ["groups", "delimiter", "value", "onBlur"]);
        return (React.createElement(Input_1.Input, tslib_1.__assign({}, props, { renderInput: function (inputProps) { return (React.createElement("div", { onClick: _this.onClick, className: classnames(moduleClassName("wrapper"), inputProps.className) }, groups.map(function (_a, index) {
                var name = _a.name, mask = _a.mask, inputProps = tslib_1.__rest(_a, ["name", "mask"]);
                var valueString = value[index] || "";
                var inputIsFilled = valueString.length === mask.length;
                return (React.createElement("span", { key: name, className: classnames(moduleClassName("group")) },
                    React.createElement("input", tslib_1.__assign({ name: name, className: moduleClassName("input"), ref: function (input) {
                            if (input) {
                                _this.inputs[index] = input;
                            }
                        }, value: value[index], onFocus: _this.onFocus, onBlur: _this.onBlur, onKeyDown: function (event) {
                            _this.onKeyDown(index, event);
                        }, onKeyUp: function (event) {
                            _this.onKeyUp(index, event);
                        }, onChange: function (event) {
                            _this.onChange(index, event);
                        }, type: props.type, maxLength: mask.length }, inputProps)),
                    React.createElement("span", { className: moduleClassName("mask") },
                        React.createElement("span", { className: moduleClassName("maskHidden") }, inputIsFilled
                            ? value[index]
                            : mask.substr(0, valueString.length)),
                        mask.substr(valueString.length)),
                    index < groups.length - 1 && (React.createElement("span", { className: moduleClassName("delimiter") }, delimiter))));
            }))); } })));
    };
    /* https://stackoverflow.com/questions/12467240/determine-if-javascript-e-keycode-is-a-printable-non-control-character */
    InputValueGroups.isPrintableKeyCode = function (keyCode) {
        return (keyCode > 47 && keyCode < 58) || // number keys
            keyCode === 32 ||
            keyCode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
            (keyCode > 64 && keyCode < 91) || // letter keys
            (keyCode > 95 && keyCode < 112) || // numpad keys
            (keyCode > 185 && keyCode < 193) || // ;=,-./` (in order)
            (keyCode > 218 && keyCode < 223);
    }; // [\]' (in order)
    return InputValueGroups;
}(React.Component));
exports.InputValueGroups = InputValueGroups;